// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin: 5px 0;
}

.pagination-search {
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #ccc;
  padding: 6px 10px;
  border-radius: 6px;
}

.pagination-search input {
  border: none;
  outline: none;
}

.pagination-info {
  font-size: 14px;
}

.pagination-controls {
  display: flex;
  gap: 6px;
}

.pagination-controls button {
  padding: 1px 10px;
  border: 1px solid #ccc;
  background: white;
  cursor: pointer;
  border-radius: 4px;
}

.pagination-controls button.active {
  background: rgb(132, 199, 174);
  color: white;
}

.pagination-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.excel-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #1d6f42;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/utils/Pagination/Pagination.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".pagination-container {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  margin: 5px 0;\n}\n\n.pagination-search {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid #ccc;\n  padding: 6px 10px;\n  border-radius: 6px;\n}\n\n.pagination-search input {\n  border: none;\n  outline: none;\n}\n\n.pagination-info {\n  font-size: 14px;\n}\n\n.pagination-controls {\n  display: flex;\n  gap: 6px;\n}\n\n.pagination-controls button {\n  padding: 1px 10px;\n  border: 1px solid #ccc;\n  background: white;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.pagination-controls button.active {\n  background: rgb(132, 199, 174);\n  color: white;\n}\n\n.pagination-controls button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.excel-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: #1d6f42;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
